import { ViewEncapsulation, Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'tr-confirm-buttons',
    templateUrl: './tr-confirm-buttons.component.html',
    styleUrls: [ './tr-confirm-buttons.component.scss' ],
    encapsulation: ViewEncapsulation.Emulated,
})
/**
 * Botões inferiores da página
 */
export class TrConfirmButtonsComponent {

    @Output() public onConfirm: EventEmitter<boolean> = new EventEmitter();
    @Output() public onCancel: EventEmitter<boolean> = new EventEmitter();

    @Input() public confirmButtonLabel: string = 'Investir';
    @Input() public cancelButtonLabel: string = 'Cancelar';
    @Input() public legalNoticeLabel: string = 'Aviso legal';

    @Input() public legalNoticeLink: string = 'https://cdn.toroinvestimentos.com.br/corretora/documents/aviso-legal.pdf';

    @Input() public enableConfirm: boolean = true;
    @Input() public enableCancel: boolean = true;
    @Input() public showLegalNotice: boolean = false;
    @Input() public renderContainer: boolean = true;
    @Input() public busy: boolean = false;

    @Input() public set mobileCancelButtonLabel(value: string) {
        this._mobileCancelButtonLabel = value;
    }

    public get mobileCancelButtonLabel(): string {
        return this._mobileCancelButtonLabel ? this.mobileCancelButtonLabel : this.cancelButtonLabel;
    }

    @Input() public set mobileConfirmButtonLabel(value: string) {
        this._mobileConfirmButtonLabel = value;
    }

    public get mobileConfirmButtonLabel(): string {
        return this._mobileConfirmButtonLabel ? this._mobileConfirmButtonLabel : this.confirmButtonLabel;
    }

    // tslint:disable-next-line:variable-name
    private _mobileConfirmButtonLabel: string;
    // tslint:disable-next-line:variable-name
    private _mobileCancelButtonLabel: string;

    public confirmClickHandler($event: Event) {
        this.onConfirm.emit(true);
    }

    public cancelClickHandler($event: Event) {
        this.onCancel.emit(true);
    }
}
